module.exports = {
      id: "icon-audio-twitter-usage",
      viewBox: "0 0 25.209 25.209",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#icon-audio-twitter",
      toString: function () {
        return this.url;
      }
    }